import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { ISSUES_GROUP } from '../../constants/api';
import { ClearFilterButton } from './ClearFilterButton';
import { LoadMore } from './LoadMore';
import { filterIssuesByType, TableRows } from './TableRows';
import { resolveFilterGroupType } from './Tabs';
export const TableContent = (props) => {
    const { showMoreBtn, className, hiddenType, twoColumns, isCommitProcessing, isCommitTimedOut, showIcon, highlightedRules, loading, loadingMore, issuesLimit, defects, moreIssuesCount, onLoadMoreClick, onRuleClick, onTypeClick, } = props;
    const group = resolveFilterGroupType(hiddenType);
    const dataFiltered = filterIssuesByType(defects, hiddenType, issuesLimit);
    const showLoadMoreButton = !!(dataFiltered.length && showMoreBtn && !loading && moreIssuesCount);
    const handleClearFilter = () => {
        if (group && group !== ISSUES_GROUP.ALL) {
            return onTypeClick(group, true);
        }
        if (highlightedRules) {
            const [firstPart, secondPart] = highlightedRules[0].split('#');
            onRuleClick(firstPart, secondPart);
        }
    };
    return _jsxs(_Fragment, { children: [_jsx(TableRows, { defects: defects, highlightedRules: highlightedRules, issuesLimit: issuesLimit, className: className, hiddenType: hiddenType, showIcon: showIcon, twoColumns: twoColumns, isLoading: loading, isCommitProcessing: isCommitProcessing, isCommitTimedOut: isCommitTimedOut, onRuleClick: onRuleClick }), _jsxs("div", { className: 'd-flex', children: [(highlightedRules?.length !== 0 || (group && group !== ISSUES_GROUP.ALL)) && _jsx(ClearFilterButton, { onClick: handleClearFilter }), showLoadMoreButton && _jsx(LoadMore, { loadingMore: loadingMore, moreIssuesCount: moreIssuesCount, onClick: onLoadMoreClick })] })] });
};
